// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Item } from '@/items/api/types';
import {
  ITEM_TYPE_DESCRIPTIONS,
  ITEM_TYPE_ICONS,
  ITEM_TYPE_LABELS,
} from '@/items/constants/item-types';
import { Chip, Tooltip } from '@mui/material';

interface Props {
  item: Pick<Item, 'type'>;
}

/**
 * A component that displays an item's type as a Material-UI chip.
 *
 * Features:
 * - Visual distinction between item types (SERVICE, DEVICE, BULK)
 * - Icon matching the item type
 * - Tooltip with description on hover
 * - Consistent sizing with other UI elements
 */
export function ItemTypeChip(props: Props) {
  const Icon = ITEM_TYPE_ICONS[props.item.type];
  const label = ITEM_TYPE_LABELS[props.item.type];
  const description = ITEM_TYPE_DESCRIPTIONS[props.item.type];

  return (
    <Tooltip title={description} arrow>
      <Chip
        icon={<Icon fontSize="small" />}
        label={label}
        size="small"
        variant="outlined"
        sx={{
          '& .MuiChip-label': {
            lineHeight: 1,
          },
        }}
      />
    </Tooltip>
  );
}
